<template>
  <div class="sign-in">
    <q-form ref="signInForm" class="form" @submit.prevent="onSubmit">
      <div class="input">
        <p class="label">Login</p>
        <q-input
          v-model="login"
          class="default-input-form input-form"
          :dark="stateStore.isBlackTheme"
          borderless
          autogrow
          lazy-rules
          :rules="[(val) => !!val || 'To pole nie może być puste']"
        />
      </div>
      <div class="input">
        <p class="label">Hasło</p>
        <q-input
          v-model="password"
          class="default-input-form input-form"
          :dark="stateStore.isBlackTheme"
          :type="isPwd ? 'password' : 'text'"
          borderless
          lazy-rules
          :rules="[(val) => !!val || 'To pole nie może być puste']"
        >
          <template #append>
            <q-icon
              :name="isPwd ? 'visibility_off' : 'visibility'"
              class="cursor-pointer"
              @click="isPwd = !isPwd"
            />
          </template>
        </q-input>
      </div>
      <button class="core-default-form-button" type="submit">
        Zaloguj się
      </button>
    </q-form>
  </div>
</template>

<script>
import { useQuasar } from 'quasar';
import { useAuthStore } from '@/stores';
import { Logger } from '../../middlewares/sentry';
import { useStateStore } from '@/stores/state.store';

export default {
  name: 'SignIn',
  setup() {
    const quasar = useQuasar();
    const authStore = useAuthStore();
    const stateStore = useStateStore();

    return {
      quasar,
      authStore,
      stateStore,
    };
  },
  data() {
    return {
      login: '',
      password: '',
      isPwd: true,
    };
  },
  methods: {
    async onSubmit() {
      if (this.login === '' || this.password === '') {
        this.quasar.notify({
          type: 'negative',
          message: `Pola nie mogą zostać puste`,
        });
        return;
      }

      try {
        const errorMsg = await this.authStore.signin(this.login, this.password);
        if (errorMsg !== '') {
          this.quasar.notify({
            type: 'negative',
            message: `Błędne dane logowania`,
          });
        }
      } catch (error) {
        this.quasar.notify({
          type: 'negative',
          message: `Błąd podczas logowania`,
        });
        Logger.warn(error);
      }

      this.name = '';
      this.email = '';
      this.$refs.signInForm.resetValidation();
    },
  },
};
</script>

<style lang="scss" scoped>
p {
  margin: 0;
}

.sign-in {
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 80%;
  margin: auto;
  padding-top: 50px;

  .form {
    display: flex;
    flex-direction: column;
    gap: 30px;

    .input {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 5px;

      .input-form {
        width: 300px;
      }
    }
  }
}
</style>
